import { useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ButtonScanQR from "./ButtonScanQR";
import { useGetUserQuotasMutation } from "../../store/services/public";
import { UserMothlySportFeeFech } from "../../models/sports-odds";
import {
  SportNameBodyTemplate,
  ExpirateBodyTemplate,
  PriceBodyTemplate,
  DebtBodyTemplate,
  ExpiratedBodyTemplate,
} from "../DataTable";
import { AssistanceTemplate } from "../DataTable/AssistanceTemplate";

export const ScanUserQuota = () => {
  const [getUserQuotas, { isLoading }] = useGetUserQuotasMutation();
  const [data, setData] = useState<UserMothlySportFeeFech[] | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [scanError, setScanError] = useState<string | null>(null);

  const handleScan = (value: string | null) => {
    if (!value) return;

    // Pattern: /institutionId/document
    // Removing leading slice if present (some scanners might add it or just handling the string format)
    // The format example is /institutionId/document

    // const parts = value.split("/");
    // We expect empty string (before first /), institutionId, document
    // Example: /123/45678 -> ["", "123", "45678"]
    // Or maybe just 123/45678 if no leading slash?
    // Let's try to be flexible.

    let institutionId = "";
    let documen = "";

    if (value.startsWith("/")) {
      const split = value.split("/");
      if (split.length >= 3) {
        institutionId = split[1];
        documen = split[2];
      }
    } else {
      // Try split by / assuming no leading slash
      const split = value.split("/");
      if (split.length >= 2) {
        institutionId = split[0];
        documen = split[1];
      }
    }

    if (institutionId && documen) {
      getUserQuotas({ institutionId, documen })
        .unwrap()
        .then((res) => {
          setData(res);
          setShowModal(true);
          setScanError(null);
        })
        .catch((err) => {
          console.error(err);
          setScanError(
            "No se pudieron obtener las cuotas. Verifique el código o intente más tarde.",
          );
        });
    } else {
      setScanError("Formato de código QR inválido. Se espera /ID/Documento");
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setData(null);
    setScanError(null);
  };

  const userInfo = data?.[0];

  return (
    <>
      <ButtonScanQR
        label="Escanear QR"
        description="Escanea el código QR para ver el estado de cuotas"
        error={scanError}
        onError={setScanError}
        onScan={handleScan}
        autoClose={true}
      />

      <Dialog
        header="Estado del Socio"
        visible={showModal}
        style={{ width: "90%", maxWidth: "800px" }}
        onHide={handleClose}
        maximizable
      >
        {userInfo && (
          <div className="surface-ground border-round p-3 mb-3">
            <div className="flex flex-column md:flex-row md:align-items-center gap-3">
              <div className="flex align-items-center gap-2">
                <i className="pi pi-user text-xl text-primary"></i>
                <span className="text-xl font-bold text-900">
                  {userInfo.lastName}, {userInfo.firstName}
                </span>
              </div>
              {/* Institution info - using ID as name is unavailble directly in response typically unless fetched */}
              <div className="flex align-items-center gap-2">
                <i className="pi pi-building text-xl text-primary"></i>
                <span className="text-700">
                  Institución: {userInfo.institutionName}
                </span>
              </div>
            </div>
          </div>
        )}

        <DataTable
          value={data || []}
          loading={isLoading}
          emptyMessage="No se encontraron cuotas para este usuario."
          scrollable
          scrollHeight="500px"
          rowClassName={() => "vertical-align-middle"}
          stripedRows
          size="small"
        >
          <Column
            header="Deporte"
            body={SportNameBodyTemplate}
            style={{ minWidth: "120px" }}
          />
          <Column
            header="¿Asistió hoy?"
            style={{ minWidth: "120px" }}
            body={AssistanceTemplate}
          />
          <Column
            header="Estado"
            body={ExpiratedBodyTemplate}
            style={{ minWidth: "120px" }}
          />
          <Column
            header="Vence"
            field="expiratedDate"
            body={ExpirateBodyTemplate}
            style={{ minWidth: "120px" }}
          />
          <Column
            header="Precio"
            body={PriceBodyTemplate}
            style={{ minWidth: "100px" }}
          />
          <Column
            header="Deuda"
            body={DebtBodyTemplate}
            style={{ minWidth: "100px" }}
          />
        </DataTable>
      </Dialog>
    </>
  );
};
